// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Favorite40FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Favorite40Filled: FC<Favorite40FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="40"
            height="40"
        >
            <path d="M36.8 14.866v.015l-.001.024-.003.066a7.284 7.284 0 0 1-.12.9 11.178 11.178 0 0 1-.75 2.324c-.786 1.785-2.262 4.073-5.019 6.44l-.568.475c-3.07 2.49-5.268 4.806-6.691 6.49a32.904 32.904 0 0 0-1.567 1.992 18.68 18.68 0 0 0-.475.69l-.003.004-1.08 1.74-1.114-1.719-.004-.006-.022-.033-.097-.143c-.088-.128-.223-.32-.404-.567a37.905 37.905 0 0 0-1.647-2.072 48.616 48.616 0 0 0-6.569-6.372c-3.141-2.521-4.768-5-5.604-6.912a11.074 11.074 0 0 1-.743-2.333 7.257 7.257 0 0 1-.116-.906l-.003-.066v-.038s0-.002 1.3-.007l-1.3.005v-.005c0-2.755.767-4.792 1.92-6.267C7.258 7.127 8.7 6.314 9.901 5.863l.366-.128a8.82 8.82 0 0 1 5.638.056l.228.084c2.193.853 3.556 2.738 4.366 4.329.838-1.645 2.268-3.605 4.594-4.413a8.82 8.82 0 0 1 5.638-.056l.366.128c1.202.453 2.642 1.265 3.782 2.723 1.152 1.474 1.92 3.51 1.92 6.266v.014Z" />
        </svg>
    );
};

export default Favorite40Filled;
